import React, { useState } from 'react';
import {
  Box,
  Typography,
  FormControlLabel,
  Checkbox,
  Paper,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Button,
} from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
// import DfhLogo from '../../utils/dfh.png';

const hiringCriteria = [
  'Must be a Permanent Resident or Citizen',
  'Must have a Valid Work Permit',
  'Must be 24 years or older',
  'Must have 1 year or more of experience'
];

export default function CriteriaToHire({ onNext, logo }) {
  const [acceptedPrivacy, setAcceptedPrivacy] = useState(false);
  const [acceptedTerms, setAcceptedTerms] = useState(false);

  const handleContinue = () => {
    if (acceptedPrivacy && acceptedTerms) {
      onNext();
    }
  };

  return (
    <Box sx={{ maxWidth: 800, mx: 'auto', p: 3 }}>
      {/* CHANGED: center logo and title */}
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', mb: 3 }}>
        <Box
          component="img"
          src={logo}
          alt="Company Logo"
          sx={{ height: logo && logo.includes('bolton-cargo') ? 200 : 80, mb: 1 }}
        />
        <Typography variant="h5">New Driver Application</Typography>
      </Box>

      <Paper sx={{ p: 3, mb: 3 }}>
        <Typography variant="h5">Hiring Requirements:</Typography>

        <List>
          {hiringCriteria.map((criterion, index) => (
            <ListItem key={index}>
              <ListItemIcon>
                <CheckCircleOutlineIcon color="primary" />
              </ListItemIcon>
              <ListItemText primary={criterion} />
            </ListItem>
          ))}
        </List>
      </Paper>

      <Box sx={{ mt: 3, flexDirection: 'column', display: 'flex' }}>
        <FormControlLabel
          control={
            <Checkbox
              checked={acceptedPrivacy}
              onChange={(e) => setAcceptedPrivacy(e.target.checked)}
            />
          }
          label="I accept DriverPath Privacy Policy"
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={acceptedTerms}
              onChange={(e) => setAcceptedTerms(e.target.checked)}
            />
          }
          label="I accept DriverPath Terms and Conditions"
        />
      </Box>

      <Box sx={{ mt: 3 }}>
        <Button
          variant="contained"
          color="primary"
          fullWidth
          disabled={!acceptedPrivacy || !acceptedTerms}
          onClick={handleContinue}
        >
          Continue
        </Button>
      </Box>
    </Box>
  );
}
